import ViewTicketPendientesAsignacionPage from "../../components/view-tickets-pendientes-asignacion-page/ViewTicketsPendientesAsignacionPage";

export default function TicketPendientesAsignacionPage() {
  return<ViewTicketPendientesAsignacionPage title="Ticket Pendientes Asignación"/>
}